import { Link } from "react-router-dom";
import styles from "./Sections.module.scss";


export default function SectionTable(props) {
    let feature = (props.data.title).toLowerCase();
  return (
        <tr>
            <td>
                {props.data.title}
            </td>
            <td>
                <Link to={`/product-list/?${feature}=${props.data.property_item_id}`} className={`${styles.lgtBlueLink} text-decoration-none`}>
                    {props.data.value}
                </Link>
            </td>
        </tr>   
  )
}
